import { ModalBody as FBModalBody } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ModalBody = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.modal.body,
    className: `overflow-visible ${props.className}`,
  };
  return <FBModalBody {...tmpProps}>{props.children}</FBModalBody>;
};

export default ModalBody;